import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "selectProps"];
import React from 'react';
import { components } from 'react-select';
export default /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    selectProps = _ref.selectProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var numSelectedLiteral = selectProps.numSelectedLiteral;
  var _children = _slicedToArray(children, 2),
    values = _children[0],
    input = _children[1];
  if (Array.isArray(values)) {
    values = numSelectedLiteral.replace('%@', values.length);
  }
  return /*#__PURE__*/React.createElement(components.ValueContainer, _extends({}, props, {
    selectProps: selectProps
  }), /*#__PURE__*/React.createElement(components.SingleValue, props, values), input);
});